import "./src/styles/global.css";
import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import awsconfig from "./src/aws-exports";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import growthbook from "./src/utils/growthbook";
import { ReviewsProvider } from "./src/contexts/ReviewsContext";
import { AuthProvider } from "./src/contexts/AuthContext";
import { getClientId } from "./src/utils/auth";

Amplify.configure(awsconfig);

const GrowthBookWrapper = ({ children }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Get client_id for GrowthBook tracking
      const clientId = getClientId();

      // Set user attributes for consistent experiment assignment
      growthbook.setAttributes({
        id: clientId,
        url: window.location.href,
        userAgent: navigator.userAgent,
      });

      // Initialize GrowthBook with streaming
      growthbook.init({ streaming: true });
    }
  }, []);

  return children;
};

export const wrapRootElement = ({ element, props }) => {
  // Skip AuthProvider for admin pages to avoid unauth session conflicts
  const isAdminPage = props?.location?.pathname?.startsWith('/admin');

  if (isAdminPage) {
    return (
      <GrowthBookProvider growthbook={growthbook}>
        <ReviewsProvider>
          <GrowthBookWrapper>{element}</GrowthBookWrapper>
        </ReviewsProvider>
      </GrowthBookProvider>
    );
  }

  return (
    <AuthProvider>
      <GrowthBookProvider growthbook={growthbook}>
        <ReviewsProvider>
          <GrowthBookWrapper>{element}</GrowthBookWrapper>
        </ReviewsProvider>
      </GrowthBookProvider>
    </AuthProvider>
  );
};
